

const resolveBrandName = (brand) => {
  if (!brand) return 'Wassini';
  if (typeof brand === 'string') return brand;
  if (typeof brand === 'object') {
    return (
      brand.name ||
      brand.title ||
      brand.label ||
      brand.brand ||
      `Brand`
    );
  }
  return 'Wassini';
};

const resolveImages = (item) => {
  const list = Array.isArray(item.images)
    ? item.images
        .map(
          (entry) =>
            entry?.imageUrl ||
            entry?.url ||
            entry?.image ||
            entry?.thumbnail ||
            null
        )
        .filter(Boolean)
    : [];

  if (!list.length && (item.image || item.thumbnail)) {
    return [item.image || item.thumbnail];
  }

  return list;
};

export const normalizeProducts = (payload) => {
  const source = Array.isArray(payload)
    ? payload
    : Array.isArray(payload?.data)
    ? payload.data
    : [];

  return source.map((item, index) => {
    const images = resolveImages(item);
    const primaryImage = images[0] || item.image || item.thumbnail;
    return {
      id: item.productId ?? item.id ?? `product-${index}`,
      productId: item.productId ?? item.id ?? `product-${index}`,
      name: item.name || item.title || `Product ${index + 1}`,
      brand: resolveBrandName(item.brand || item.designer),
      images,
      price: Number(item.price ?? item.currentPrice ?? item.sellingPrice ?? 0),
      sellingPrice: Number(item.sellingPrice ?? item.price ?? item.currentPrice ?? 0),
      oldPrice: item.oldPrice != null ? Number(item.oldPrice) : null,
      currency: item.currency || '$',
      image: primaryImage,
      description: item.description || item.summary || '',
      shipping: item.shipping ?? null,
      discount: Boolean(item.discount),
      discountPercentage: Number(item.discountPercentage ?? 0),
      favorite: Boolean(
        item.favorite ??
        item.isFavorite ??
        item.favoritesId ??
        item.favoriteId
      ),
      favoriteId:
        item.favoriteId ||
        item.favoritesId ||
        item.favorite_entry_id ||
        item.favorite?.id ||
        null,
      variants: Array.isArray(item.variants)
        ? item.variants.map((variant, variantIndex) => {
          const color = variant.color || variant.colour || {};
          const colorCode = color.code || color.hex || null;
          const colorName = color.name || null;
          const colorId =
            color.colorId ||
            color.id ||
            variant.colorId ||
            variant.colourId ||
            `color-${index}-${variantIndex}`;
          const size = variant.size || {};
          const sizeId =
            size.sizeId ||
            size.id ||
            variant.sizeId ||
            null;
          const sizeName = size.name || variant.sizeName || null;

          const variantImages = Array.isArray(variant.images)
            ? variant.images
                .map(
                  (entry) =>
                    entry?.imageUrl ||
                    entry?.url ||
                    entry?.image ||
                    entry?.thumbnail ||
                    null
                )
                .filter(Boolean)
            : [];

          const primaryVariantImage =
            variantImages[0] ||
            variant.imageUrl ||
            variant.image ||
            variant.thumbnail ||
            primaryImage;

          return {
            id: variant.variantId ?? `variant-${index}-${variantIndex}`,
            variantId: variant.variantId ?? `variant-${index}-${variantIndex}`,
            image: primaryVariantImage,
            images:
              variantImages.length > 0
                ? variantImages
                : [primaryVariantImage || primaryImage].filter(Boolean),
            colorName,
            colorCode,
            colorId,
            sizeId,
            sizeName,
            price:
              variant.price != null
                ? Number(variant.price)
                : variant.sellingPrice != null
                ? Number(variant.sellingPrice)
                : Number(item.price ?? 0),
            priceOverride:
              variant.priceOverride != null
                ? Number(variant.priceOverride)
                : null,
            oldPrice:
              variant.oldPrice != null
                ? Number(variant.oldPrice)
                : item.oldPrice != null
                ? Number(item.oldPrice)
                : null,
            discount:
              typeof variant.discount === 'boolean'
                ? variant.discount
                : item.discount ?? null,
            discountPercentage: Number(
              variant.discountPercentage ?? item.discountPercentage ?? 0
            ),
            stock: variant.stock ?? variant.quantity ?? null,
            outOfStock: Boolean(variant.outOfStock),
          };
        })
        : [],
    };
  });
};

export default normalizeProducts;
